exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TagList {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  list-style-type: none;\n  bottom: 10px;\n  right: 10px;\n  height: 20px; }\n  .TagList-Element {\n    margin-left: 5px; }\n", ""]);

// exports
